import styled from 'styled-components'

export const Favorite = styled.div`
    height: 16px;
    width: 16px;
    cursor: pointer;
    margin-right: 30px;
    margin-top: 0px;

    @keyframes pulse {
        from { transform: scale3d(1, 1, 1) }
        50% { transform: scale3d(1.1, 1.1, 1.1) }
        to { transform: scale3d(1, 1, 1) }
    }
    svg {
        width: 100%;
        animation-name: ${props => props.wasFilled ? 'pulse' : ''};
        animation-duration: .7s;
        animation-fill-mode: both;
    }
`
